export default __webpack_public_path__ + "static/media/MAKEUP.3cc4a015.jpg";